module.exports = __webpack_public_path__ + "static/media/litigation.6c382237.jpg";